export default {
  name: "limit",
  in: "query",
  required: false,
  description: "Specifies the maximum number of results.",
  schema: {
    type: "integer",
    example: 20
  }
};
